const web = {
  name: 'Rikzan Fernanda',
  note: 'Web Development | Fullstack Engineer Anthusiast',
  summary:
    'My name is Rikzan Fernanda from Indonesia. I am a computer science student at Dian Nuswantoro University in Semarang, Central Java. My current expertise is software engineer. I can work in frontend and backend. I have worked on several projects with Codeigniter 3, Laravel 8, Lumen and also React JS.',
  links: {
    linkedin: 'https://www.linkedin.com/in/rikzan-fernanda-9097831ab/',
    github: 'https://github.com/rikzanfernanda'
  }
}

export default web
